import React from 'react';

const HamburgerButton = ({ isOpen, onClick, className = '' }) => {
    return (
        <button 
            className={`hamburger-button ${isOpen ? 'open' : ''} ${className}`}
            onClick={onClick}
            aria-label="Toggle navigation menu"
        >
            <div className="hamburger-lines">
                <span className="line line1"></span>
                <span className="line line2"></span>
                <span className="line line3"></span>
            </div>
        </button>
    );
};

export default HamburgerButton; 